import { render, staticRenderFns } from "./edit_news.vue?vue&type=template&id=4166273d&"
import script from "./edit_news.vue?vue&type=script&lang=js&"
export * from "./edit_news.vue?vue&type=script&lang=js&"
import style0 from "./edit_news.vue?vue&type=style&index=0&id=4166273d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports